const HexNumber = {
  print: ({ node }) => node.value
};

module.exports = HexNumber;
